import React from 'react'
import styled from 'styled-components'
import Plyr from 'react-plyr'
import './plyr.css'

const Div = styled.div`
  vertical-align: top;
  height: auto;
  max-width: 116%;
  width: 116%;
  margin-top: 8vw;
  margin-bottom: 8vw;
  margin-left: calc(100% / -12);
  position: relative;
  /* height: 56%; */
  /* padding-bottom: 65.25%; */
  /* height: calc(100% * 1.777); */
  /* margin-right: calc(100% / -12); */
  @media (max-width: 40em) {
    margin-top: 40px;
    margin-bottom: 40px;
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    /* padding-bottom: 56.25%; */
  }
`

const Video = ({ id }) => {
  return (
    <Div>
      <Plyr
        hideControls
        controls={['play', 'progress', 'current-time', 'volume']}
        type='youtube' // or "vimeo"
        videoId={id}
      />
    </Div>
    // <Div>
    //   <iframe
    //     title='Video embed'
    //     style={{ position: 'absolute', top: 0, bottom: 0, left: 0, height: '100%', width: '100%' }}
    //     src={src}
    //     frameBorder='0'
    //     allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
    //     allowFullScreen
    //   />
    // </Div>
  )
}

export default Video
